/**
 * @author Sai Prasad
 * @class ItemSpecifications
 */

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Actions from '../../components/Actions';
import Search from '../../components/Search';
import Button from '../../components/Button';
import Empty from '../../components/Empty';
import Overlay from '../../components/Overlay';
import Icon from '../../components/Icon';
import SpecificationForm from '../../components/SpecificationForm/SpecificationForm';

import { onSaveSpecification, fetchSpecifications, clearSpecifications, onUpdateSpecification, onDeleteSpecification } from '../../store/actions/items';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { setSearch } from '../../store/actions/search';
import { selectSpecifications } from '../../store/selectors/Specifications';
import { stopPRLoading } from '../../store/actions/loader';
import { onCheckUserCanAccessTheModule } from '../../helpers/validationHelper';
import { USER_ROLES } from '../../common/constants';

const ItemSpecifications = ({
  item
}) => {
  const dispatch = useDispatch();
  const [showOverlay, setShowOverlay] = useState(false);
  const [specification, setSpecification] = useState({});
  const loader = useSelector(state => selectPRLoader(state));
  const specificationsList = useSelector(state => selectSpecifications(state));
  const isEnabled = onCheckUserCanAccessTheModule([USER_ROLES.SUPER_ADMIN,USER_ROLES.ADMIN,USER_ROLES.PROPERTY_DEVELOPER]);

  useEffect(() => {
    dispatch(stopPRLoading());
    dispatch(clearSpecifications());
    dispatch(fetchSpecifications(item.id));
  }, []);

  const onSetShowOverlay = (value) => {
    setShowOverlay(value)
  }

  const saveSpecification = (params) => {
    if (params && params.id) {
      dispatch(onUpdateSpecification(params));
    } else {
      dispatch(onSaveSpecification(params));
    }
  }
  const onClose = () => {
    onSetShowOverlay(false);
    setSpecification({});
  }
  const onSearch = (e) => {
    dispatch(setSearch({ specifications: e.target.value.trim() }));
  }
  const editSpecification = (data) => {
    setSpecification(data);
    onSetShowOverlay(true);
  }
  const deleteSpecification = (data) => {
    dispatch(onDeleteSpecification(data.id));
  }
  return (
    loader ? <Loader center={true} /> :
      <div className="faqs">
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Specifications..."
            onChange={onSearch}
          />
          {isEnabled &&
          <Button
            color="teal"
            label="Add Specification"
            onClick={() => onSetShowOverlay(true)}
            icon={(
              <Icon
                glyph="edit"
                weight="light"
                size="small"
              />
            )}
            size="small"
          />}
        </Actions>
        {specificationsList.length > 0 ? specificationsList.map((item, i) => {
          return (
            <div
              key={i}
              className="faqs__faq"
            >
              <div className="faqs__question">
                {item.title}
                {isEnabled &&
                <div className="faqs__actions">
                  <Button
                    color="semantic"
                    onClick={() => editSpecification(item)}
                    label={(
                      <Icon
                        glyph="pencil"
                        weight="light"
                      />
                    )}
                  />
                  <Button
                    color="semantic"
                    onClick={() => window.confirm(`Are you sure you want to delete specification?`) && deleteSpecification(item)}
                    label={(
                      <Icon
                        glyph="trash"
                        weight="light"
                      />
                    )}
                  />
                </div>}
              </div>
              <div className="faqs__answer">
                {<div dangerouslySetInnerHTML={{ __html: item.description }} />}
              </div>
            </div>
          )
        })
          : (
            <Empty
              headline="No Specifications yet"
              cta={(
                isEnabled &&
                <Button
                  color="teal"
                  label="Add Specification"
                  onClick={() => onSetShowOverlay(true)}
                  icon={(
                    <Icon
                      glyph="edit"
                      weight="light"
                      size="small"
                    />
                  )}
                  size="small"
                />
              )}
              image={(
                <img
                  alt="No Specifications yet"
                  src="/assets/empty/notes.svg"
                />
              )}
            />
          )}
        <Overlay
          showOverlay={showOverlay}
          content={(
            <SpecificationForm
              itemId={item.id}
              breadcrumb={item.name}
              specification={specification}
              onClose={onClose}
              onSaveSpecification={saveSpecification}
            />
          )}
        />
      </div>
  )
}

export default ItemSpecifications;